<script setup lang="ts">
import type { IProps } from './career-searchResults.types'
import type { IOffer } from '@/types/shared-types'
import UiButton from '@/components/UiButton/UiButton.vue'
import CareerERecruiterOffer from '~/domains/career/components/career-eRecruiterOffer/career-eRecruiterOffer.vue'

withDefaults(defineProps<IProps>(), {
  limit: 6,
})

const currentPage = ref<number>(1)

</script>

<template>
  <div
    class="Search-Results"
    :class="{'Search-Results--with-wrapper': withWrapper}"
  >
    <div class="Search-Results__container">
      <div>
        <UiHeader
          :header="header"
          :header-size="showResults ? 'h5' : 'h4'"
          header-size-mobile="h3"
          header-size-tablet="h3"
          position="left"
        />
        <p
          v-if="showResults"
          class="Search-Results__subheader"
        >
          Liczba wyników: {{ (cards as IOffer[]).length }}
        </p>
      </div>

      <div class="Search-Results__boxContainer">
        <CareerERecruiterOffer
          v-for="card in cards?.slice(0, showResults ? currentPage * limit : limit)"
          :key="card.id"
          :offer="card"
        />
      </div>

      <div
        v-if="link || (textLink && cards?.length > limit)"
        class="Search-Results__linkContainer"
      >
        <UiButton
          v-if="showResults && cards?.length > currentPage * limit"
          @clicked="currentPage = currentPage + 1"
        >
          {{ textLink }}
        </UiButton>
        <UiButton
          v-else-if="!showResults && link"
          :to="link"
          :target="target"
        >
          {{ textLink }}
        </UiButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.Search-Results {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 2rem 2.4rem;

  &--with-wrapper {
    padding: 0;
  }

  &__subheader {
    @include body-3-medium;
    margin-top: 1rem;
    color: $text-300;
  }

  &__container {
    display: flex;
    flex-direction: column;
    max-width: 136rem;
    width: 100%;
  }

  &__boxContainer {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 1.5rem 2rem;
    width: 100%;
    margin: 3.2rem 0 0 0;
  }

  &__linkContainer {
    display: flex;
    margin: 3.2rem auto 0;
    :deep(.button) {
      @include body-1-medium;
      display: flex;
      height: auto;
      padding: 0;
      color: $text-400;
      text-align: center;
      background-color: transparent;
      border-bottom: 1px solid $purple-400;
      border-radius: 0;
    }
  }
}

@include atXS {
  .Search-Results {
    &__boxContainer {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@include atM {
  .Search-Results {
    width: 100%;
    padding: 4rem 1rem;

    &--with-wrapper {
      padding: 0;
    }

    &__boxContainer {
      grid-template-columns: repeat(3, 1fr);
      margin: 4rem 0 0;
    }

    &__linkContainer {
      margin-top: 6.4rem;
      :deep(.button) {
        @include h9;
      }
    }
  }
}
</style>
